import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import CheckBoxViewModel from '@/ViewModels/Controls/CheckBoxViewModel';
import PrincipalHistorizationSelectionItemViewModel from '@/ViewModels/Controls/PrincipalHistorizationSelectionItemViewModel';

export default class PrincipalHistorizationSelectionViewModel extends ControlViewModel {

    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    private CheckBoxViewModel = ComponentManager.getViewModel<typeof CheckBoxViewModel>('CheckBoxViewModel');

    /**
     * Beinhaltet die selektierbaren Werte
     */
    public items: KnockoutObservable<PrincipalHistorizationSelectionItemViewModel[]>;

    /**
     * Die Überschrift
     */
    public label: LabelViewModel;

    /**
     * Die CheckBox zum Anhaken aller Mandanten
     */
    public checkbox: CheckBoxViewModel;

    /**
     * Das ViewModel für den PrincipalHistorizationSelection
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.items = this.observableOrDefault(params.items, []);

        this.label = new this.LabelViewModel({
            parentLocator: this.locator,
            locator: 'label',
            ergName: 'HISTORIZABLE_PRINCIPALS'
        });

        this.checkbox = new this.CheckBoxViewModel({
            parentLocator: this.locator,
            locator: 'select-all',
            isVisible: this.defineComputed( () => {
                return this.items().filter( (item: PrincipalHistorizationSelectionItemViewModel) => { return item.isEnabled(); }).length > 0;
            }),
            onClick: (isChecked: boolean) => {
                let items = this.items();

                for (let i = 0; i < items.length; i++) {
                    if (items[i].isEnabled() === true) {
                        items[i].checkbox.isChecked(isChecked);
                    }
                }
            }
        });
    }

    /**
     * Gibt an, ob mindestens ein Mandant selektiert ist
     */
    public isAnyPrincipalSelected(): boolean {
        let items = this.items();

        for (let i = 0; i < items.length; i++) {
            if (items[i].checkbox.isChecked() === true) {
                return true;
            }
        }
        return false;
    }
}

ComponentManager.setViewModel('PrincipalHistorizationSelectionViewModel', PrincipalHistorizationSelectionViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');